import React, { Component } from 'react';
class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            hasError: false,
            errorInfo: null,
        };
    }
    static getDerivedStateFromError() {
        return { hasError: true, errorInfo: null };
    }
    componentDidCatch(error, errorInfo) {
        if (process.env.NODE_ENV === 'development') {
            console.error('Uncaught error:', error, errorInfo);
        }
        this.setState({ errorInfo: { error, errorInfo } });
    }
    render() {
        if (this.state.hasError) {
            return (this.props.fallback || React.createElement("div", { "data-testid": "error-boundary" }, "Something went wrong."));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXJyb3JCb3VuZGFyeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9FcnJvckJvdW5kYXJ5LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEtBQUssRUFBRSxFQUFFLFNBQVMsRUFBYSxNQUFNLE9BQU8sQ0FBQztBQWVwRCxNQUFNLGFBQWMsU0FBUSxTQUFpRDtJQUE3RTs7UUFDVyxVQUFLLEdBQXVCO1lBQy9CLFFBQVEsRUFBRSxLQUFLO1lBQ2YsU0FBUyxFQUFFLElBQUk7U0FDbEIsQ0FBQztJQXFCTixDQUFDO0lBbkJVLE1BQU0sQ0FBQyx3QkFBd0I7UUFDbEMsT0FBTyxFQUFFLFFBQVEsRUFBRSxJQUFJLEVBQUUsU0FBUyxFQUFFLElBQUksRUFBRSxDQUFDO0lBQy9DLENBQUM7SUFFTSxpQkFBaUIsQ0FBQyxLQUFZLEVBQUUsU0FBcUM7UUFDeEUsSUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLFFBQVEsS0FBSyxhQUFhLEVBQUUsQ0FBQztZQUN6QyxPQUFPLENBQUMsS0FBSyxDQUFDLGlCQUFpQixFQUFFLEtBQUssRUFBRSxTQUFTLENBQUMsQ0FBQztRQUN2RCxDQUFDO1FBQ0QsSUFBSSxDQUFDLFFBQVEsQ0FBQyxFQUFFLFNBQVMsRUFBRSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDdkQsQ0FBQztJQUVNLE1BQU07UUFDVCxJQUFJLElBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxFQUFFLENBQUM7WUFDdEIsT0FBTyxDQUNILElBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxJQUFJLDRDQUFpQixnQkFBZ0IsNEJBQTRCLENBQ3ZGLENBQUM7UUFDTixDQUFDO1FBQ0QsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLFFBQVEsQ0FBQztJQUMvQixDQUFDO0NBQ0o7QUFFRCxlQUFlLGFBQWEsQ0FBQyJ9